import { flatMap, isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../pages/insurance/content/sections';
import mapTermsAndConditions from '../map-terms-and-conditions';

// @ts-expect-error - Automatic, Please fix when editing this file
const mapTermsAndConditionsContent = ({ cmsSectionContent }) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  const mappedTermsAndConditions = {
    terms: flatMap(mapTermsAndConditions, cmsSectionContent),
    type: CONTENT_SECTIONS.TERMS_AND_CONDITIONS,
  };

  return mappedTermsAndConditions;
};

export default mapTermsAndConditionsContent;
